export const MatchModeDateOptions = [
    { label: 'Menor', value: 'lt', },
    { label: 'Menor o Igual', value: 'lte' },
    { label: 'Mayor', value: 'gt' },
    { label: 'Mayor o Igual', value: 'gte' }
]

export const MatchModeTextOptions = [
    { label: 'Contiene', value: 'contains', },
    { label: 'No Contiene', value: 'notContains' },
    { label: 'Igual', value: 'equals' },
    { label: 'No Igual', value: 'notEquals' }
]